import rollupsHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/rollups-header.png';
import rollupsSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section1.png';
import rollupsSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section2.png';
import rollupsSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/rollups-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_ROLLUPS: PageblockData = {
  headerData: {
    headerText: 'Simplify data aggregation with scalable rollups',
    subHeaderText:
      'Create up-to-date, AI-powered documentation with clear metadata descriptions and comprehensive dependency mapping for seamless org management.',
    imgSrc: rollupsHeader,
    imgAlt: 'Rollups header',
    name: 'Rollups',
  },
  pageTitle: 'Optimize Salesforce management with AI-powered documentation',
  section1: {
    imgSrc: rollupsSection1,
    imgAlt: 'Rollups section img',
    title: 'Rollup data from any relationship',
    content:
      'Effortlessly aggregate data across both master-detail and lookup relationships within Salesforce, eliminating mid-configuration frustration.',
  },
  section2: {
    imgSrc: rollupsSection2,
    imgAlt: 'Rollups section 2 img',
    title: 'Scalable architecture – no CPU timeouts',
    content:
      'Benefit from a robust architecture designed to handle large data volumes efficiently, ensuring rollup processes complete without CPU timeouts.',
  },
  section3: {
    imgSrc: rollupsSection3,
    imgAlt: 'Rollups section 3 img',
    title: 'Use rollups to trigger automation',
    content:
      'Leverage rollup fields to initiate automated workflows and processes throughout your Salesforce organization, enhancing operational efficiency.',
  },
};
